// Archivo: ui/TransferBatchDetailView.js

import React from 'react';

export default function TransferBatchDetailView({ batch }) {
    if (!batch) return null;

    const getStatusBadgeColor = (status) => {
        switch (status) {
            case 'aprobado': return 'bg-green-100 text-green-700';
            case 'pendiente': return 'bg-yellow-100 text-yellow-700';
            case 'rechazado': return 'bg-red-100 text-red-700';
            default: return 'bg-gray-100 text-gray-700';
        }
    };

    const actionText = batch.status === 'aprobado' ? 'Aprobado' : 'Rechazado';

    return (
        <div className="text-sm text-gray-700 space-y-4">
            <div className="p-4 bg-gray-50 rounded-lg border">
                <h3 className="font-bold text-lg text-gray-800">Detalle del Lote de Traslado</h3>
                <p className="font-mono text-xs text-gray-500 mt-1">{batch.batchId}</p>
                <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 text-xs">
                    <span className="font-semibold">Solicitado por:</span>
                    <span>{batch.requester}</span>

                    <span className="font-semibold">Fecha de Solicitud:</span>
                    <span>{batch.createdAt}</span>

                    <span className="font-semibold">Estado:</span>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${getStatusBadgeColor(batch.status)}`}>
                        {batch.status}
                    </span>
                    
                    {batch.status !== 'pendiente' && (
                        <>
                            <span className="font-semibold">{actionText} por:</span>
                            <span>{batch.approver || '--'}</span>

                            <span className="font-semibold">Fecha de Proceso:</span>
                            <span>{batch.approvedAt || '--'}</span>
                        </>
                    )}
                </div>
            </div>

            <div className="overflow-y-auto max-h-[45vh] border rounded-lg">
                <table className="w-full">
                    <thead className="bg-gray-100 sticky top-0">
                        <tr>
                            <th className="p-2 text-left text-sm font-semibold text-gray-600">Producto</th>
                            <th className="p-2 text-left text-sm font-semibold text-gray-600">Origen</th>
                            <th className="p-2 text-left text-sm font-semibold text-gray-600">Destino</th>
                            <th className="p-2 text-right text-sm font-semibold text-gray-600">Cantidad</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {batch.items.map(item => (
                            <tr key={item.id} className="border-t">
                                <td className="p-2 font-medium">
                                    {/* --- CAMBIO: Se asegura que se muestre el nombre del producto y el diseño --- */}
                                    <p>{item.productName} ({item.size}, {item.color})</p>
                                    {item.designName !== 'Liso' && <p className="text-xs text-indigo-500">{item.designName}</p>}
                                </td>
                                <td className="p-2">{item.originLocationName}</td>
                                <td className="p-2">{item.destinationLocationName}</td>
                                <td className="p-2 text-right font-bold">{item.quantity}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            <div className="flex justify-end font-bold text-gray-800 pt-2 border-t">
                <span>Cantidad Total de Productos: {batch.totalQuantity}</span>
            </div>
        </div>
    );
}